var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTextColor24 = function SvgIconTextColor24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.849H5v-1.8h10v1.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9 6.949v11H9.1v-11h1.8ZM16.981 10.336l-.67.522-.671-.522a.85.85 0 0 1 1.341 0Zm-.67 1.978c-.134.198-.278.417-.42.647-.275.443-.538.914-.73 1.35-.202.458-.286.792-.286.987 0 .79.645 1.435 1.435 1.435.791 0 1.435-.644 1.435-1.435 0-.195-.083-.529-.285-.986a11.324 11.324 0 0 0-.73-1.35c-.143-.231-.286-.45-.42-.648Zm0-1.456-.671-.522-.003.003-.006.008-.021.028-.077.102a22.157 22.157 0 0 0-1.087 1.59 12.984 12.984 0 0 0-.842 1.56c-.227.516-.429 1.114-.429 1.671a3.138 3.138 0 0 0 3.135 3.135 3.138 3.138 0 0 0 3.135-3.135c0-.557-.202-1.155-.429-1.671a12.984 12.984 0 0 0-.84-1.561 22.157 22.157 0 0 0-1.165-1.691l-.021-.028-.006-.008-.003-.003-.67.522Z",
    fill: "current"
  })));
};
export default SvgIconTextColor24;